<template>
  <div class="hero">
    <div class="hero__image" v-if="image">
      <Image :data="image"/>
    </div>

    <div class="hero__container container">
      <div class="hero__content">
        <div class="hero__logo">
          <Icon data-aos="fade" name="logo/logo"/>
        </div>

        <div class="hero__title" v-if="title" data-aos="fade" data-aos-delay="25">
          <h1> {{ title }}</h1>
          <Tooltip :data="tooltipData" @onClick="tooltipClick" ref="tooltip"/>

          <div class="hero__tooltip-text" v-if="showTooltip">
            {{ tooltipText }}
          </div>
        </div>

        <p class="hero__text" v-if="text" data-aos="fade" data-aos-delay="50">
          {{ text }}
        </p>

        <div class="hero__action" v-if="dirty" data-aos="fade" data-aos-delay="100">
          <AppButton :data="actionContinue" @onClick="start"/>
        </div>
        <div class="hero__action" data-aos="fade" data-aos-delay="100" v-else>
          <AppButton :data="actionStart" @onClick="start"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Image from '@/components/Image/Image.vue';
import Icon from '@/components/Icon/Icon.vue';
import AppButton from '@/components/AppButton/AppButton.vue';
import { mapGetters, mapMutations } from 'vuex';
import Tooltip from '@/components/Tooltip/Tooltip.vue';

export default {
  name: 'Hero',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tooltipData: {
        icon: '24/info',
        text: 'Закалка подразумевает быстрое охлаждение металла для приведения механических свойств в исходное состояние',
      },
      tooltipText: 'Закалка подразумевает быстрое охлаждение металла для приведения механических свойств в исходное состояние',
      showTooltip: false,
    };
  },
  components: {
    Tooltip,
    AppButton,
    Icon,
    Image,
  },
  computed: {
    ...mapGetters({
      getProgramData: 'app/getProgramData',
      getFirstProgramId: 'app/getFirstProgramId',
      getNextProgramId: 'app/getNextProgramId',
      getDoneMeditationArray: 'app/getDoneMeditationArray',
    }),

    title() {
      return this.data.title;
    },
    text() {
      return this.data.text;
    },
    image() {
      return this.data.image;
    },
    actionStart() {
      return this.data.actionStart;
    },
    actionContinue() {
      return this.data.actionContinue;
    },

    // ни одна из медитаций не была запущена
    dirty() {
      return this.getDoneMeditationArray && this.getDoneMeditationArray.length;
    },
  },
  methods: {
    ...mapMutations({
      setAppMode: 'app/setMode',
      setCurrentProgramId: 'app/setCurrentProgramId',
    }),

    start() {
      // начинаем со следующей медитации, если такая есть
      if (this.getNextProgramId) {
        this.setCurrentProgramId(this.getNextProgramId);
        this.setAppMode('first-check');
      } else {
        // всегда начинаем с первой, если все пройдены
        this.setCurrentProgramId(this.getFirstProgramId);
        this.setAppMode('first-check');
      }
    },
    tooltipClick() {
      this.showTooltip = !this.showTooltip;
    },
    hideTooltip(e) {
      if (!e.target.classList.contains('tooltip')
          && !e.target.classList.contains('hero__tooltip-text')) {
        this.showTooltip = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.hideTooltip);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.hideTooltip);
  },
};
</script>

<style lang="scss" scoped>
@import "Hero";
</style>
